import React from 'react';
import { ForgeButton } from '@tylertech/forge-react';
import PropTypes from 'prop-types';
import {
  SSO_PROVIDER_PBB,
  SSO_PROVIDER_TYLER,
} from '../../static/keyWords.js';

const LoginButtons = ({
  onLogin,
  multipleSsoEnabled = false,
  defaultProvider = SSO_PROVIDER_TYLER,
  disabled = false,
}) => {
  const renderButtons = () => {
    const buttons = multipleSsoEnabled
      ? [
        {
          id: 'tyler-login-button',
          text: 'Sign in',
          provider: SSO_PROVIDER_TYLER,
          variant: 'raised',
        },
        {
          id: 'pbb-login-button',
          text: 'Sign in with PBB',
          provider: SSO_PROVIDER_PBB,
          variant: 'outlined',
        },
      ]
      : [
        {
          id: 'login-button',
          text: 'Sign in',
          provider: defaultProvider,
          variant: 'raised',
        },
      ];

    return buttons.map((button) => (
      <ForgeButton
        key={button.id}
        id={button.id}
        type="button"
        variant={button.variant}
        fullWidth
        disabled={disabled}
        onClick={() => onLogin(button.provider)}
      >
        <span>{button.text}</span>
      </ForgeButton>
    ));
  };

  return (
    <div className="loginButtons">
      {renderButtons()}
    </div>
  );
};

LoginButtons.propTypes = {
  onLogin: PropTypes.func.isRequired,
  multipleSsoEnabled: PropTypes.bool,
  defaultProvider: PropTypes.oneOf([
    SSO_PROVIDER_PBB,
    SSO_PROVIDER_TYLER,
  ]),
  disabled: PropTypes.bool,
};

export default LoginButtons;
